export default "__VITE_ASSET__BR36n5ez__"